import { render, staticRenderFns } from "./GridSreadsheet.vue?vue&type=template&id=35c86d56"
import script from "./GridSreadsheet.vue?vue&type=script&lang=js"
export * from "./GridSreadsheet.vue?vue&type=script&lang=js"
import style0 from "./GridSreadsheet.vue?vue&type=style&index=0&id=35c86d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports